<template>
  <div class="home">
    <!-- 轮播图区域 - 动画效果完整保留 -->
    <section 
      class="hero-section"
      :style="{ height: heroSectionHeight + 'px' }"
      @mouseenter="stopAutoPlay"
      @mouseleave="startAutoPlay"
    >
      <div 
        class="hero-carousel"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
        @mousedown="handleMouseDown"
        @mousemove="handleMouseMove"
        @mouseup="handleMouseUp"
        @mouseleave="handleMouseUp"
      >
        <div 
          v-for="(banner, index) in bannerList"
          :key="banner.id"
          class="hero-slide"
          :class="{ active: index === currentIndex, dragging: isDragging }"
          :style="getSlideStyle(banner.image, index)"
        >
          <div class="hero-content" :class="{ animate: index === currentIndex }">
            <h1 class="hero-title">{{ banner.title }}</h1>
            <p class="hero-subtitle">{{ banner.subtitle }}</p>
            <a :href="banner.link" class="hero-btn">了解更多</a>
          </div>
        </div>
      </div>
      
      <div class="hero-scroll-hint">
        <div class="scroll-icon">
          <span></span>
        </div>
        <span class="scroll-text">下滑继续浏览</span>
      </div>
    </section>

    <!-- 关于新恒丰 ABOUT XINHENGFENG -->
    <section class="about-section">
      <div class="container">
        <div class="section-header-wrap" data-aos="fade-up">
          <div class="section-en-title">ABOUT XINHENGFENG</div>
          <div class="section-cn-title">关于新恒丰</div>
          <div class="section-title-bar"></div>
        </div>

        <div class="about-content">
          <div class="about-left" data-aos="fade-right">
            <p class="about-desc">{{ aboutInfo.description }}</p>
            <div class="about-stats" ref="aboutStatsRef">
              <div
                v-for="(stat, index) in aboutStats"
                :key="index"
                class="about-stat-item"
                data-aos="zoom-in"
                :data-aos-delay="index * 150"
              >
                <div class="stat-num">
                  <CountTo :end-val="stat.value" :duration="2200" :start-trigger="isStatsVisible" />
                  <span v-if="stat.suffix" class="stat-suffix">{{ stat.suffix }}</span>
                </div>
                <div class="stat-label">{{ stat.label }}</div>
              </div>
            </div>
          </div>
          <div class="about-right" data-aos="fade-left">
            <div class="about-image">
              <div class="about-img-placeholder about-img-main">
                <img src="/static/gy.png" alt="新恒丰集团" data-aos="zoom-in" />
              </div>
              <div class="about-img-placeholder about-img-2">
                <img src="/static/gy.png" alt="新恒丰集团" data-aos="zoom-in" data-aos-delay="150" />
              </div>
            </div>
          </div>
        </div>

        <!-- 资质卡片 -->
        <div class="qualification-cards">
          <div
            v-for="(qual, index) in qualifications"
            :key="index"
            class="qual-card"
            data-aos="fade-up"
            :data-aos-delay="index * 150"
          >
            <div class="qual-text">
              <h4>{{ qual.title }}</h4>
              <p>{{ qual.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务项目横幅 -->
    <section class="services-banner">
      <!-- <div class="banner-overlay"></div> -->
     <!-- <div class="container banner-content" data-aos="fade-up">
        <h2 class="banner-title">以精湛的技术、科学的管理</h2>
        <p class="banner-subtitle">为业主提供卓越的技术服务</p>
      </div> -->
    </section>

    <!-- 服务项目 OUR SERVICES -->
    <section class="services-section">
      <div class="container">
        <div class="services-header" data-aos="fade-up">
          <div class="services-en-title">OUR SERVICES</div>
          <div class="services-cn-title">服务项目</div>
        </div>
      </div>

      <!-- 一行通栏列：悬停/触摸当前列整列变色 -->
      <div class="services-grid">
        <div
          v-for="(service, index) in servicesList"
          :key="service.id"
          class="service-col"
          data-aos="fade-up"
          :data-aos-delay="index * 80"
          @touchstart="handleServiceTouchStart"
          @touchend="handleServiceTouchEnd"
          @click="goToService(service.id)"
        >
          <div class="service-icon">
            <img :src="service.image" :alt="service.name" />
          </div>
          <h4 class="service-name">{{ service.name }}</h4>
          <div class="service-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </section>

    <!-- 新闻动态 NEWS DYNAMICS -->
    <section class="news-section">
      <div class="container">
        <div class="section-header-wrap" data-aos="fade-up">
          <div class="section-en-title">NEWS DYNAMICS</div>
          <div class="section-cn-title">新闻动态</div>
          <div class="section-title-bar"></div>
          <a href="/news" class="section-more-link">更多动态 →</a>
        </div>

        <div class="news-content">
          <div class="news-left" data-aos="fade-right">
            <div
              class="news-featured"
              @mouseenter="stopNewsAutoPlay"
              @mouseleave="handleNewsMouseLeave"
              @touchstart="handleNewsTouchStart"
              @touchmove="handleNewsTouchMove"
              @touchend="handleNewsTouchEnd"
              @mousedown="handleNewsMouseDown"
            >
              <div
                v-for="(news, index) in newsList.slice(0, 3)"
                :key="news.id"
                class="news-featured-item"
                :class="{ active: index === currentNewsIndex, dragging: newsIsDragging }"
                :style="{
                  backgroundImage: `url(${news.image})`,
                  opacity: getSlideOpacity(index),
                  zIndex: getSlideZIndex(index)
                }"
              >
                <div class="news-featured-overlay">
                  <div class="news-featured-info">
                    <span class="news-category-tag">{{ news.category }}</span>
                    <span class="news-date-tag">{{ news.date }}</span>
                  </div>
                  <h3 class="news-featured-title">{{ news.title }}</h3>
                </div>
              </div>
              <div class="news-featured-indicators">
                <span
                  v-for="(_, index) in newsList.slice(0, 3)"
                  :key="index"
                  :class="{ active: index === currentNewsIndex }"
                  @click="goToNewsSlide(index)"
                ></span>
              </div>
            </div>
          </div>

          <div class="news-right" data-aos="fade-left">
            <div
              v-for="(news, index) in newsList.slice(0, 2)"
              :key="'side-'+news.id"
              class="news-item"
              data-aos="fade-up"
              :data-aos-delay="index * 150"
            >
              <div class="news-item-category">{{ news.category }}</div>
              <h4 class="news-item-title">{{ news.title }}</h4>
              <div class="news-item-meta">
                <span><i class="el-icon-time"></i> {{ news.date }}</span>
              </div>
              <p class="news-item-summary">{{ news.summary }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 案例展示 CASE PRESENTATION -->
    <section class="cases-section">
      <div class="container">
        <div class="section-header-wrap" data-aos="fade-up">
          <div class="section-en-title">CASE PRESENTATION</div>
          <div class="section-cn-title">案例展示</div>
          <div class="section-title-bar"></div>
          <a href="/cases" class="section-more-link">更多案例 →</a>
        </div>

        <div class="cases-grid">
          <div
            v-for="(caseItem, index) in casesList.slice(0, 4)"
            :key="caseItem.id"
            class="case-card"
            data-aos="fade-up"
            :data-aos-delay="(index % 4) * 120"
          >
            <div class="case-image">
              <img :src="caseItem.image" :alt="caseItem.name" data-aos="zoom-in">
              <div class="case-category-badge">{{ caseItem.category }}</div>
            </div>
            <div class="case-info">
              <h4 class="case-name">{{ caseItem.name }}</h4>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作单位 COOPERATING UNITS -->
    <section class="partners-section">
      <div class="container">
        <div class="section-header-wrap" data-aos="fade-up">
          <div class="section-en-title">COOPERATING UNITS</div>
          <div class="section-cn-title">合作单位</div>
          <div class="section-title-bar"></div>
        </div>

        <div class="partners-grid">
          <div
            class="partner-item"
            v-for="(partner, index) in partnersList"
            :key="index"
            data-aos="zoom-in"
            :data-aos-delay="(index % 6) * 80"
          >
            <div class="partner-logo-wrap">
              <img :src="partner" alt="合作单位" class="partner-img">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业社会责任 CSR -->
    <section class="csr-section">
      <div class="container">
        <div class="section-header-wrap" data-aos="fade-up">
          <div class="section-en-title">CORPORATE SOCIAL RESPONSIBILITY</div>
          <div class="section-cn-title">社会责任</div>
          <div class="section-title-bar"></div>
        </div>

        <div class="csr-grid">
          <div
            v-for="(csr, index) in csrList"
            :key="index"
            class="csr-card"
            data-aos="fade-up"
            :data-aos-delay="index * 150"
          >
            <img src="/static/jt.png" :alt="csr" data-aos="zoom-in">
            <div class="csr-overlay">
              <h4>{{ csr }}</h4>
            </div>
          </div>
        </div>
      </div>
    </section>


  </div>
</template>

<script>
import { mockBanner, mockNews, mockServices, mockCases, mockAbout } from '@/api/mock'

export default {
  name: 'Home',
  data() {
    return {
      bannerList: mockBanner,
      newsList: mockNews,
      servicesList: mockServices,
      casesList: mockCases,
      aboutInfo: mockAbout,
      partnersList: [
        '/static/hz/hz1.png', '/static/hz/hz2.png', '/static/hz/hz3.png', '/static/hz/hz4.png',
        '/static/hz/hz5.png', '/static/hz/hz6.png', '/static/hz/hz7.png', '/static/hz/hz8.png',
        '/static/hz/hz9.png', '/static/hz/hz10.png'
      ],
      aboutStats: [
        { value: 1998, label: '成立年份' },
        { value: 70, label: '专业人才' },
        { value: 64, label: '服务项目' },
        { value: 80, label: '合作伙伴' }
      ],
      qualifications: [
        { title: '综合甲级', desc: '工程咨询单位资格' },
        { title: '专业甲级', desc: '工程造价咨询资质' },
        { title: '专项甲级', desc: '工程招标代理资质' }
      ],
      csrList: ['公益慈善', '绿色环保', '志愿服务'],
      isStatsVisible: false,
      statsObserver: null,
      currentIndex: 0,
      timer: null,
      startX: 0,
      currentX: 0,
      isDragging: false,
      isSwitching: false,
      dragStartTime: 0,
      scrollY: 0,
      scrollScale: 1,
      isScrollTicking: false,
      currentNewsIndex: 0,
      newsTimer: null,
      newsStartX: 0,
      newsCurrentX: 0,
      newsIsDragging: false,
      newsIsSwitching: false,
      newsCarouselWidth: 0,
      newsDragStartTime: 0
    }
  },
  computed: {
    threshold() {
      return 80
    },
    heroSectionHeight() {
      const baseHeight = 750
      const minHeight = 400
      const progress = (1 - this.scrollScale) / 0.4
      return Math.max(minHeight, baseHeight - (baseHeight - minHeight) * progress)
    },
    heroScrollStyle() {
      const bgPosY = 50 + this.scrollY * 0.15
      const progress = 1 - this.scrollScale
      const translateY = progress * (750 - this.heroSectionHeight) * 0.5
      const transform = this.isDragging ? `translate3d(0px, ${translateY}px, 0px) scaleY(${this.scrollScale})` : `translateY(${translateY}px) scaleY(${this.scrollScale})`
      return {
        backgroundPosition: `center ${bgPosY}%`,
        transform: transform,
        transformOrigin: 'top center'
      }
    }
  },
  mounted() {
    this.startAutoPlay()
    this.startNewsAutoPlay()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.$nextTick(() => {
      this.updateNewsCarouselWidth()
      this.observeStats()
    })
    window.addEventListener('resize', this.updateNewsCarouselWidth)
  },
  beforeDestroy() {
    this.stopAutoPlay()
    this.stopNewsAutoPlay()
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.updateNewsCarouselWidth)
    if (this.statsObserver) {
      this.statsObserver.disconnect()
      this.statsObserver = null
    }
  },
  methods: {
    handleServiceTouchStart(e) {
      // 命令式添加 active 类，避免 Vue patch class 覆盖 AOS 的 aos-animate
      e.currentTarget.classList.add('active')
    },
    handleServiceTouchEnd(e) {
      e.currentTarget.classList.remove('active')
    },
    goToService(id) {
      this.$router.push(`/services#service-${id}`)
    },
    observeStats() {
      const el = this.$refs.aboutStatsRef
      if (!el || typeof IntersectionObserver === 'undefined') {
        // 兜底:不支持时直接显示
        this.isStatsVisible = true
        return
      }
      this.statsObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isStatsVisible = true
            this.statsObserver.disconnect()
            this.statsObserver = null
          }
        })
      }, { threshold: 0.3 })
      this.statsObserver.observe(el)
    },
    startAutoPlay() {
      this.stopAutoPlay()
      this.timer = setInterval(() => {
        this.nextSlide()
      }, 5000)
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    goToSlide(index) {
      if (index === this.currentIndex) return
      this.currentIndex = index
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.bannerList.length
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.bannerList.length) % this.bannerList.length
    },
    handleTouchStart(e) {
      this.startX = e.touches[0].clientX
      this.currentX = 0
      this.isDragging = true
      this.dragStartTime = Date.now()
      this.stopAutoPlay()
    },
    handleTouchMove(e) {
      if (!this.isDragging) return
      this.currentX = e.touches[0].clientX - this.startX
    },
    handleTouchEnd() {
      if (!this.isDragging) return
      this.isDragging = false
      this.handleSlide()
      this.currentX = 0
      this.startAutoPlay()
    },
    handleMouseDown(e) {
      this.startX = e.clientX
      this.currentX = 0
      this.isDragging = true
      this.dragStartTime = Date.now()
      this.stopAutoPlay()
    },
    handleMouseMove(e) {
      if (!this.isDragging) return
      this.currentX = e.clientX - this.startX
    },
    handleMouseUp() {
      if (!this.isDragging) return
      this.isDragging = false
      this.handleSlide()
      this.currentX = 0
      this.startAutoPlay()
    },
    handleSlide() {
      if (this.isSwitching) return
      const dragDuration = Date.now() - this.dragStartTime
      const distanceThreshold = 150
      const timeThreshold = 300
      const shouldSwitch = Math.abs(this.currentX) > distanceThreshold || dragDuration < timeThreshold
      if (shouldSwitch && Math.abs(this.currentX) > 30) {
        this.isSwitching = true
        if (this.currentX < 0) {
          this.nextSlide()
        } else {
          this.prevSlide()
        }
        setTimeout(() => {
          this.isSwitching = false
        }, 600)
      }
    },
    handleScroll() {
      if (this.isScrollTicking) return
      this.isScrollTicking = true
      requestAnimationFrame(() => {
        const scrollTop = window.scrollY || window.pageYOffset
        const heroHeight = 750
        
        if (scrollTop < heroHeight) {
          this.scrollY = scrollTop * 0.5
          const progress = scrollTop / heroHeight
          this.scrollScale = 1 - progress * 0.4
        } else {
          this.scrollY = heroHeight * 0.5
          this.scrollScale = 0.6
        }
        this.isScrollTicking = false
      })
    },
    getSlideStyle(image, index) {
      return {
        backgroundImage: `url(${image})`,
        backgroundPosition: this.heroScrollStyle.backgroundPosition,
        opacity: this.getHeroSlideOpacity(index),
        zIndex: this.getHeroSlideZIndex(index),
        transform: this.heroScrollStyle.transform,
        transformOrigin: this.heroScrollStyle.transformOrigin
      }
    },
    getHeroSlideOpacity(index) {
      if (!this.isDragging) {
        return index === this.currentIndex ? 1 : 0
      }
      const maxIndex = this.bannerList.length - 1
      const dragDistance = Math.abs(this.currentX)
      const maxDrag = 1200
      const clampedRatio = Math.max(0, Math.min(dragDistance / maxDrag, 1))
      
      if (index === this.currentIndex) {
        return 1 - clampedRatio
      }
      
      if (this.currentX < 0) {
        const nextIndex = (this.currentIndex + 1) % (maxIndex + 1)
        if (index === nextIndex) {
          return clampedRatio
        }
      } else {
        const prevIndex = (this.currentIndex - 1 + (maxIndex + 1)) % (maxIndex + 1)
        if (index === prevIndex) {
          return clampedRatio
        }
      }
      
      return 0
    },
    getHeroSlideZIndex(index) {
      if (!this.isDragging) {
        return index === this.currentIndex ? 10 : 1
      }
      if (index === this.currentIndex) {
        return 10
      }
      if (this.currentX < 0) {
        const maxIndex = this.bannerList.length - 1
        const nextIndex = (this.currentIndex + 1) % (maxIndex + 1)
        if (index === nextIndex) {
          return 9
        }
      } else {
        const maxIndex = this.bannerList.length - 1
        const prevIndex = (this.currentIndex - 1 + (maxIndex + 1)) % (maxIndex + 1)
        if (index === prevIndex) {
          return 9
        }
      }
      return 1
    },
    startNewsAutoPlay() {
      this.stopNewsAutoPlay()
      this.newsTimer = setInterval(() => {
        this.nextNewsSlide()
      }, 5000)
    },
    stopNewsAutoPlay() {
      if (this.newsTimer) {
        clearInterval(this.newsTimer)
        this.newsTimer = null
      }
    },
    goToNewsSlide(index) {
      if (index === this.currentNewsIndex) return
      this.currentNewsIndex = index
    },
    nextNewsSlide() {
      const maxIndex = Math.min(this.newsList.length, 3) - 1
      this.currentNewsIndex = (this.currentNewsIndex + 1) % (maxIndex + 1)
    },
    prevNewsSlide() {
      const maxIndex = Math.min(this.newsList.length, 3) - 1
      this.currentNewsIndex = (this.currentNewsIndex - 1 + (maxIndex + 1)) % (maxIndex + 1)
    },
    updateNewsCarouselWidth() {
      const carousel = document.querySelector('.news-featured')
      if (carousel) {
        this.newsCarouselWidth = carousel.offsetWidth
      }
    },
    handleNewsTouchStart(e) {
      this.newsStartX = e.touches[0].clientX
      this.newsCurrentX = 0
      this.newsIsDragging = true
      this.newsDragStartTime = Date.now()
      this.stopNewsAutoPlay()
    },
    handleNewsTouchMove(e) {
      if (!this.newsIsDragging) return
      this.newsCurrentX = e.touches[0].clientX - this.newsStartX
    },
    handleNewsTouchEnd() {
      if (!this.newsIsDragging) return
      this.newsIsDragging = false
      this.handleNewsSlide()
      this.newsCurrentX = 0
      this.startNewsAutoPlay()
    },
    handleNewsMouseDown(e) {
      this.newsStartX = e.clientX
      this.newsCurrentX = 0
      this.newsIsDragging = true
      this.newsDragStartTime = Date.now()
      this.stopNewsAutoPlay()
      window.addEventListener('mousemove', this.handleNewsMouseMove)
      window.addEventListener('mouseup', this.handleNewsMouseUp)
    },
    handleNewsMouseMove(e) {
      if (!this.newsIsDragging) return
      this.newsCurrentX = e.clientX - this.newsStartX
    },
    handleNewsMouseUp() {
      if (!this.newsIsDragging) return
      this.newsIsDragging = false
      window.removeEventListener('mousemove', this.handleNewsMouseMove)
      window.removeEventListener('mouseup', this.handleNewsMouseUp)
      this.handleNewsSlide()
      this.newsCurrentX = 0
      this.startNewsAutoPlay()
    },
    handleNewsMouseLeave() {
      if (this.newsIsDragging) {
        this.newsIsDragging = false
        window.removeEventListener('mousemove', this.handleNewsMouseMove)
        window.removeEventListener('mouseup', this.handleNewsMouseUp)
        this.handleNewsSlide()
        this.newsCurrentX = 0
      }
      this.startNewsAutoPlay()
    },
    handleNewsSlide() {
      if (this.newsIsSwitching) return
      const dragDuration = Date.now() - this.newsDragStartTime
      const distanceThreshold = 150
      const timeThreshold = 300
      const shouldSwitch = Math.abs(this.newsCurrentX) > distanceThreshold || dragDuration < timeThreshold
      if (shouldSwitch && Math.abs(this.newsCurrentX) > 30) {
        this.newsIsSwitching = true
        if (this.newsCurrentX < 0) {
          this.nextNewsSlide()
        } else {
          this.prevNewsSlide()
        }
        setTimeout(() => {
          this.newsIsSwitching = false
        }, 600)
      }
    },
    getSlideOpacity(index) {
      if (!this.newsIsDragging) {
        return index === this.currentNewsIndex ? 1 : 0
      }
      const maxIndex = Math.min(this.newsList.length, 3) - 1
      const dragDistance = Math.abs(this.newsCurrentX)
      const maxDrag = 500
      const clampedRatio = Math.max(0, Math.min(dragDistance / maxDrag, 1))
      
      if (index === this.currentNewsIndex) {
        return 1 - clampedRatio
      }
      
      if (this.newsCurrentX < 0) {
        const nextIndex = (this.currentNewsIndex + 1) % (maxIndex + 1)
        if (index === nextIndex) {
          return clampedRatio
        }
      } else {
        const prevIndex = (this.currentNewsIndex - 1 + (maxIndex + 1)) % (maxIndex + 1)
        if (index === prevIndex) {
          return clampedRatio
        }
      }
      
      return 0
    },
    getSlideZIndex(index) {
      if (!this.newsIsDragging) {
        return index === this.currentNewsIndex ? 10 : 1
      }
      if (index === this.currentNewsIndex) {
        return 10
      }
      if (this.newsCurrentX < 0) {
        const maxIndex = Math.min(this.newsList.length, 3) - 1
        const nextIndex = (this.currentNewsIndex + 1) % (maxIndex + 1)
        if (index === nextIndex) {
          return 9
        }
      } else {
        const maxIndex = Math.min(this.newsList.length, 3) - 1
        const prevIndex = (this.currentNewsIndex - 1 + (maxIndex + 1)) % (maxIndex + 1)
        if (index === prevIndex) {
          return 9
        }
      }
      return 1
    }
  }
}
</script>

<style lang="scss" scoped>
/* ===== 轮播图样式 - 完整保留原有动画效果 ===== */
.hero-section {
  position: relative;
  height: 750px;
  overflow: hidden;
  transition: height 0.1s ease-out;
}

.hero-carousel {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: grab;
  user-select: none;

  &:active {
    cursor: grabbing;
  }
}

.hero-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  opacity: 0;
  z-index: 1;
  transition: opacity 1.6s ease;
  will-change: opacity, transform;
  backface-visibility: hidden;

  &.active {
    opacity: 1;
    z-index: 10;
  }

  &.dragging {
    transition: none !important;
  }
}

.hero-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 20px;

  &.animate {
    .hero-title {
      animation: fadeInUp 0.6s ease forwards;
    }

    .hero-subtitle {
      animation: fadeInUp 0.6s ease 0.2s forwards;
      opacity: 0;
    }

    .hero-btn {
      animation: fadeInUp 0.6s ease 0.4s forwards;
      opacity: 0;
    }
  }
}

.hero-title {
  font-size: 52px;
  font-weight: bold;
  color: white;
  margin-bottom: 20px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.8), 0 4px 40px rgba(0, 0, 0, 0.5);
  opacity: 0;
  transform: translateY(30px);
}

.hero-subtitle {
  font-size: 26px;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 40px;
  max-width: 800px;
  text-shadow: 0 1px 10px rgba(0, 0, 0, 0.8);
  opacity: 0;
  transform: translateY(30px);
}

.hero-btn {
  padding: 14px 40px;
  background: #c8102e;
  border: 2px solid #c8102e;
  color: white;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(30px);

  &:hover {
    background: #a00d25;
    border-color: #a00d25;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-scroll-hint {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 20;
  animation: bounceScroll 2s ease-in-out infinite;
}

.scroll-icon {
  width: 30px;
  height: 50px;
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 15px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 8px;

  span {
    width: 6px;
    height: 12px;
    background: white;
    border-radius: 3px;
    animation: scrollArrow 1.5s ease-in-out infinite;
  }
}

.scroll-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

@keyframes scrollArrow {
  0%, 100% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(15px);
    opacity: 0.5;
  }
}

@keyframes bounceScroll {
  0%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(-10px);
  }
}

/* ===== 通用区块标题 ===== */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header-wrap {
  text-align: center;
  margin-bottom: 50px;
  position: relative;

  .section-en-title {
    font-size: 14px;
    color: #c8102e;
    letter-spacing: 4px;
    font-weight: 600;
    margin-bottom: 10px;
    text-transform: uppercase;
  }

  .section-cn-title {
    font-size: 34px;
    color: #1e293b;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .section-title-bar {
    width: 60px;
    height: 4px;
    background: linear-gradient(90deg, #c8102e, #e63946);
    margin: 0 auto;
    border-radius: 2px;
  }

  .section-more-link {
    position: absolute;
    right: 0;
    bottom: 10px;
    font-size: 14px;
    color: #64748b;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #c8102e;
    }
  }
}

/* ===== 关于新恒丰 ===== */
.about-section {
  padding: 80px 0;
  background: #ffffff;
}

.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  margin-bottom: 60px;
  align-items: center;
}

.about-left {
  .about-desc {
    font-size: 16px;
    line-height: 2;
    color: #475569;
    margin-bottom: 40px;
  }
}

.about-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.about-stat-item {
  text-align: center;
  padding: 20px 10px;
  background: #f8fafc;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #fff5f5, #ffe8ea);
    transform: translateY(-3px);
  }

  .stat-num {
    font-size: 38px;
    font-weight: bold;
    color: #c8102e;
    margin-bottom: 8px;
    font-family: 'Arial', sans-serif;
  }

  .stat-label {
    font-size: 13px;
    color: #64748b;
  }
}

.about-right {
  .about-image {
    position: relative;

    .about-img-placeholder {
      border-radius: 8px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
      position: relative;

      img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
	  overflow: hidden;
    }

    .about-img-main {
      width: 100%;
      padding-top: 75%;
      background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
    }

    .about-img-2 {
		overflow: hidden;
      position: absolute;
      bottom: -30px;
      left: -30px;
      width: 45%;
	  height: 200px;
      // padding-top: 35%;
      background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
      border: 5px solid white;
    }
  }
}

.qualification-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 60px;
}

.qual-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 30px;
  background: linear-gradient(135deg, #e63946 0%, #c8102e 100%);
  border-radius: 8px;
  color: white;
  transition: all 0.4s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(200, 16, 46, 0.3);
  }

  .qual-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &.qual-icon-1 {
      background: rgba(255, 255, 255, 0.25);
      box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.3);
    }

    &.qual-icon-2 {
      background: rgba(255, 255, 255, 0.25);
      box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.3);
    }

    &.qual-icon-3 {
      background: rgba(255, 255, 255, 0.25);
      box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.3);
    }
  }

  .qual-text {
    h4 {
      font-size: 22px;
      margin-bottom: 6px;
      font-weight: bold;
    }

    p {
      font-size: 14px;
      opacity: 0.9;
      margin: 0;
    }
  }
}

/* ===== 服务项目横幅 ===== */
.services-banner {
  position: relative;
  height: 380px;
  background: url('/static/homebj.png') no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 40%, rgba(20, 60, 120, 0.85) 100%);
  }

  .banner-content {
    position: relative;
    z-index: 2;
    text-align: center;
    color: white;

    .banner-title {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 15px;
      text-shadow: 0 2px 20px rgba(0, 0, 0, 0.5);
      letter-spacing: 2px;
    }

    .banner-subtitle {
      font-size: 22px;
      font-weight: 400;
      text-shadow: 0 2px 15px rgba(0, 0, 0, 0.5);
      letter-spacing: 3px;
    }
  }
}

/* ===== 服务项目（一行通栏，悬停/触摸整列变色） ===== */
.services-section {
  position: relative;
  min-height: 620px;
  padding: 70px 0 0;
  background: linear-gradient(180deg, #1e5099 0%, #143c78 55%, #0d2c5c 100%);
  overflow: hidden;

  /* 城市剪影装饰 */
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 120px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath fill='%230a1a2d' d='M0,120 L0,60 L50,60 L50,40 L80,40 L80,55 L120,55 L120,30 L150,30 L150,50 L180,50 L180,35 L220,35 L220,55 L260,55 L260,25 L290,25 L290,45 L330,45 L330,20 L360,20 L360,40 L400,40 L400,30 L430,30 L430,50 L470,50 L470,35 L510,35 L510,55 L550,55 L550,28 L580,28 L580,48 L620,48 L620,18 L650,18 L650,38 L690,38 L690,28 L720,28 L720,48 L760,48 L760,32 L800,32 L800,52 L840,52 L840,22 L870,22 L870,42 L910,42 L910,32 L940,32 L940,52 L980,52 L980,38 L1020,38 L1020,55 L1060,55 L1060,30 L1090,30 L1090,50 L1130,50 L1130,40 L1170,40 L1170,55 L1200,55 L1200,120 Z'/%3E%3C/svg%3E") no-repeat bottom center;
    background-size: 100% 120px;
    z-index: 0;
    opacity: 0.5;
  }

  .container {
    position: relative;
    z-index: 3;
  }
}

.services-header {
  text-align: center;
  margin-bottom: 50px;

  .services-en-title {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    letter-spacing: 6px;
    font-weight: 500;
    margin-bottom: 12px;
  }

  .services-cn-title {
    font-size: 32px;
    color: white;
    font-weight: bold;
    letter-spacing: 4px;
  }
}

/* 通栏一行列 */
.services-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  z-index: 1;
}

.service-col {
  flex: 1 1 0;
  min-width: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
  transition: background-color 0.35s ease;

  &:last-child {
    border-right: none;
  }

  /* 桌面端悬停：仅在支持 hover 的设备生效，避免移动端粘连 */
  @media (hover: hover) {
    &:hover {
      background: #2955ca;

      .service-icon {
        border-color: rgba(255, 255, 255, 0.9);
        background: rgba(255, 255, 255, 0.12);
      }

      .service-arrow {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  /* 触摸：按下时当前列背景变为 #2955CA，抬起还原 */
  &.active {
    background: #2955ca;

    .service-icon {
      border-color: rgba(255, 255, 255, 0.9);
      background: rgba(255, 255, 255, 0.12);
    }

    .service-arrow {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .service-icon {
    width: 72px;
    height: 72px;
    margin-bottom: 18px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.35s ease;

    img {
      width: 38px;
      height: 38px;
      object-fit: contain;
      filter: brightness(0) invert(1);
      opacity: 0.95;
    }
  }

  .service-name {
    font-size: 15px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.92);
    text-align: center;
    line-height: 1.4;
    margin: 0;
  }

  /* 红色箭头按钮：默认隐藏占位，激活时出现 */
  .service-arrow {
    width: 36px;
    height: 36px;
    margin-top: 18px;
    border-radius: 50%;
    background: #c8102e;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    opacity: 0;
    transform: translateY(12px);
    transition: all 0.35s ease;
    box-shadow: 0 6px 16px rgba(200, 16, 46, 0.4);
  }
}

/* ===== 新闻动态 ===== */
.news-section {
  padding: 80px 0;
  background: white;
}

.news-content {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 40px;
}

.news-featured {
  position: relative;
  height: 420px;
  border-radius: 10px;
  overflow: hidden;
  cursor: grab;
  user-select: none;

  &:active {
    cursor: grabbing;
  }
}

.news-featured-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  opacity: 0;
  z-index: 1;
  will-change: opacity;
  transition: opacity 0.8s ease;

  &.dragging {
    transition: none !important;
  }
}

.news-featured-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.8) 100%);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 40px;
  color: white;
}

.news-featured-info {
  margin-bottom: 15px;

  .news-category-tag {
    display: inline-block;
    padding: 4px 12px;
    background: #c8102e;
    color: white;
    font-size: 12px;
    border-radius: 4px;
    margin-right: 10px;
  }

  .news-date-tag {
    font-size: 13px;
    opacity: 0.85;
  }
}

.news-featured-title {
  font-size: 22px;
  font-weight: bold;
  line-height: 1.5;
}

.news-featured-indicators {
  position: absolute;
  bottom: 25px;
  right: 30px;
  display: flex;
  gap: 8px;
  z-index: 20;

  span {
    width: 10px;
    height: 10px;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;

    &.active {
      width: 28px;
      border-radius: 5px;
      background: white;
    }
  }
}

.news-right {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.news-item {
  padding: 25px;
  background: #f8fafc;
  border-radius: 10px;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;

  &:hover {
    background: white;
    border-left-color: #c8102e;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
    transform: translateX(5px);
  }

  .news-item-category {
    display: inline-block;
    padding: 3px 10px;
    background: #c8102e;
    color: white;
    font-size: 12px;
    border-radius: 4px;
    margin-bottom: 12px;
  }

  .news-item-title {
    font-size: 17px;
    font-weight: bold;
    color: #1e293b;
    margin-bottom: 10px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .news-item-meta {
    font-size: 13px;
    color: #94a3b8;
    margin-bottom: 12px;

    i {
      margin-right: 5px;
    }
  }

  .news-item-summary {
    font-size: 14px;
    color: #64748b;
    line-height: 1.7;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0;
  }
}

/* ===== 案例展示 ===== */
.cases-section {
  padding: 80px 0;
  background: #f8fafc;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.case-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.4s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);

    .case-image img {
      transform: scale(1.1);
    }
  }

  .case-image {
    position: relative;
    height: 220px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s ease;
    }

    .case-category-badge {
      position: absolute;
      top: 15px;
      left: 15px;
      padding: 5px 14px;
      background: #c8102e;
      color: white;
      font-size: 12px;
      border-radius: 4px;
      font-weight: 500;
    }
  }

  .case-info {
    padding: 20px;

    .case-name {
      font-size: 16px;
      font-weight: 600;
      color: #1e293b;
      line-height: 1.5;
      margin: 0;
    }
  }
}

/* ===== 合作单位 ===== */
.partners-section {
  padding: 80px 0;
  background: white;
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.partner-item {
  .partner-logo-wrap {
    height: 90px;
    background: #f8fafc;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    border: 1px solid #e2e8f0;

    &:hover {
      background: white;
      border-color: #c8102e;
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(200, 16, 46, 0.1);
    }

    .partner-img {
      max-width: 80%;
      max-height: 60px;
      object-fit: contain;
    }
  }
}

/* ===== 社会责任 ===== */
.csr-section {
  padding: 80px 0;
  background: #f8fafc;
}

.csr-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
}

.csr-card {
  position: relative;
  height: 260px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .csr-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, transparent 40%, rgba(0, 0, 0, 0.75) 100%);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 30px;
    transition: all 0.4s ease;

    h4 {
      color: white;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 2px;
      margin: 0;
    }
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);

    img {
      transform: scale(1.08);
    }

    .csr-overlay {
      background: linear-gradient(180deg, rgba(200, 16, 46, 0.4) 0%, rgba(200, 16, 46, 0.8) 100%);
    }
  }
}

/* ===== 响应式 ===== */
@media (max-width: 992px) {
  .hero-title {
    font-size: 36px;
  }

  .hero-subtitle {
    font-size: 20px;
  }

  .about-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .about-right {
    .about-image .about-img-2 {
      left: 20px;
    }
  }

  .about-stats {
    grid-template-columns: repeat(4, 1fr);
  }

  .qualification-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .services-banner {
    height: 300px;

    .banner-content {
      .banner-title {
        font-size: 28px;
      }

      .banner-subtitle {
        font-size: 18px;
      }
    }
  }

  .services-section {
    min-height: 540px;
  }

  .service-col {
    .service-icon {
      width: 60px;
      height: 60px;

      img {
        width: 32px;
        height: 32px;
      }
    }

    .service-name {
      font-size: 14px;
    }
  }

  .news-content {
    grid-template-columns: 1fr;
  }

  .news-featured {
    height: 350px;
  }

  .cases-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .partners-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .csr-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .hero-section {
    height: 400px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .about-stat-item .stat-num {
    font-size: 28px;
  }

  .about-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .section-header-wrap .section-cn-title {
    font-size: 26px;
  }

  .section-header-wrap .section-more-link {
    position: static;
    display: block;
    margin-top: 15px;
  }

  .services-banner {
    height: 250px;

    .banner-content {
      .banner-title {
        font-size: 22px;
      }

      .banner-subtitle {
        font-size: 16px;
      }
    }
  }

  .services-section {
    min-height: 480px;
    padding-top: 50px;
  }

  .services-header {
    margin-bottom: 36px;

    .services-cn-title {
      font-size: 26px;
    }
  }

  .service-col {
    padding: 0 4px;

    .service-icon {
      width: 48px;
      height: 48px;
      margin-bottom: 12px;
      border-radius: 4px;

      img {
        width: 26px;
        height: 26px;
      }
    }

    .service-name {
      font-size: 12px;
      line-height: 1.3;
    }

    .service-arrow {
      width: 28px;
      height: 28px;
      margin-top: 12px;
      font-size: 14px;
    }
  }

  .cases-grid {
    grid-template-columns: 1fr;
  }

  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .news-featured-title {
    font-size: 18px;
  }

  .news-featured {
    height: 280px;
  }

  .news-featured-overlay {
    padding: 25px;
  }
}

/* ===== 小屏手机适配 ===== */
@media (max-width: 480px) {
  .about-section,
  .news-section,
  .cases-section,
  .partners-section,
  .csr-section {
    padding: 50px 0;
  }

  .section-header-wrap {
    margin-bottom: 35px;

    .section-en-title {
      font-size: 12px;
      letter-spacing: 3px;
    }

    .section-cn-title {
      font-size: 22px;
    }
  }

  .hero-title {
    font-size: 22px;
    margin-bottom: 12px;
  }

  .hero-subtitle {
    font-size: 14px;
    margin-bottom: 24px;
  }

  .hero-btn {
    padding: 10px 26px;
    font-size: 14px;
  }

  .about-left .about-desc {
    font-size: 14px;
    line-height: 1.8;
    margin-bottom: 25px;
  }

  .about-stat-item {
    padding: 14px 6px;

    .stat-num {
      font-size: 24px;
    }

    .stat-label {
      font-size: 12px;
    }
  }

  .qual-card {
    padding: 22px;
    gap: 14px;

    .qual-text h4 {
      font-size: 18px;
    }
  }

  .services-section {
    min-height: 420px;
    padding-top: 40px;
  }

  .services-banner {
    height: 200px;

    .banner-content {
      .banner-title {
        font-size: 18px;
        letter-spacing: 1px;
      }

      .banner-subtitle {
        font-size: 14px;
        letter-spacing: 2px;
      }
    }
  }

  .services-header {
    margin-bottom: 35px;

    .services-en-title {
      font-size: 12px;
      letter-spacing: 4px;
    }

    .services-cn-title {
      font-size: 22px;
    }
  }

  .service-col {
    padding: 0 2px;

    .service-icon {
      width: 42px;
      height: 42px;
      margin-bottom: 10px;

      img {
        width: 22px;
        height: 22px;
      }
    }

    .service-name {
      font-size: 11px;
    }

    .service-arrow {
      width: 24px;
      height: 24px;
      margin-top: 10px;
      font-size: 12px;
    }
  }

  .news-featured {
    height: 240px;
  }

  .news-featured-overlay {
    padding: 18px;
  }

  .news-featured-title {
    font-size: 16px;
  }

  .news-item {
    padding: 18px;

    .news-item-title {
      font-size: 15px;
    }

    .news-item-summary {
      font-size: 13px;
    }
  }

  .case-image {
    height: 180px;
  }

  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    .partner-logo-wrap {
      height: 70px;

      .partner-img {
        max-height: 50px;
      }
    }
  }

  .csr-card {
    height: 200px;

    .csr-overlay {
      padding-bottom: 20px;

      h4 {
        font-size: 17px;
      }
    }
  }
}
</style>
